import { Component, Output, EventEmitter, Input } from '@angular/core';
import { EStatus } from '../../../core/enums/status.enum';

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
})
export class ActionButtonsComponent {
  @Input() overallStatus = '';
  @Input() actionsEnabled = true;
  @Input() permissions: string[] = ['APPLICATION_APPROVE', 'APPLICATION_QUERY', 'APPLICATION_REJECT'];
  @Output() approve = new EventEmitter<void>();
  @Output() query = new EventEmitter<void>();
  @Output() reject = new EventEmitter<void>();

  EStatus = EStatus;

  get visible(): boolean {
    return (
      this.actionsEnabled &&
      this.overallStatus !== EStatus.FINALLY_APPROVED &&
      this.overallStatus !== EStatus.FINALLY_REJECTED &&
      this.overallStatus !== EStatus.PENDING_VERIFICATION &&
      this.overallStatus !== EStatus.PARTIALLY_REVIEWED
    );
  }
}
